"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
const lit_element_1 = require("lit-element");
exports.styles = lit_element_1.css `
    :host,
    :host(:hover),
    :host(:active),
    :host([active]) {
        --primary-button-color: var(--primary-color);
        --font-color: #fff;
        --hv-button-text-transform: default;
        --border-radius: 10px;
        --hv-button-height: 56px;
        --hv-button-font-size: 20px;
    }
`;
exports.default = {
    // styles
    styles: exports.styles,
};
